import React, { useState, useEffect } from 'react';

interface TypewriterEffectProps {
  text: string;           // Text to type out
  speed?: number;          // Milliseconds between each character
  className?: string;
  onComplete?: () => void; // Callback when typing finishes
}

/**
 * TypewriterEffect: Displays text character by character with typing animation
 * Shows a blinking cursor while typing
 */
const TypewriterEffect: React.FC<TypewriterEffectProps> = ({ 
  text, 
  speed = 50,  // Default: 50ms per character
  className = "",
  onComplete 
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      // Add next character after delay
      const timer = setTimeout(() => {
        setDisplayText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timer);  // Cleanup timer
    } else if (onComplete) {
      // All characters typed, call completion callback
      onComplete();
    }
  }, [currentIndex, text, speed, onComplete]);

  return (
    <span className={className}>
      {displayText}
      <span className="animate-pulse">|</span>
    </span>
  );
};

export default TypewriterEffect; 